import { useState, useEffect } from "react";

/**
 * Hook that returns a boolean indicating whether the given media query matches.
 * @param query The media query to check
 * @returns Boolean indicating if the media query matches
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(false);

  useEffect(() => {
    // Create a media query list
    const mediaQuery = window.matchMedia(query);
    
    // Initial check
    setMatches(mediaQuery.matches);

    // Define the change handler
    const handler = (e: MediaQueryListEvent) => {
      setMatches(e.matches);
    };

    // Add the listener
    mediaQuery.addEventListener("change", handler);
    
    // Cleanup: remove the listener when the component is unmounted
    return () => {
      mediaQuery.removeEventListener("change", handler);
    };
  }, [query]);

  return matches;
}
